module.exports = __webpack_public_path__ + "202408221624/img/img_card_pos.4511f0a9.png";